import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Button } from 'antd';
import Tooltip from '../common/Tooltip';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { zoomList } from '../../constants/constants';
import { resolveZoom, readStoredZoom } from '../../utils/zoom';
import { useStore } from '../../store/store';
import NavbarSelector from './NavbarSelector';

// Le groupe du zoom encadre un champ à coins droits : ses boutons restent
// carrés. Le thème donne à tous les boutons une forme en pilule
// (pillButtonComponentsTheme), qui sur un carré de 32px les rendait ronds.
const zoomButtonStyle = { borderRadius: 4 };

export const ZoomControl = () => {
  const { t } = useTranslation();
  const setZoom = useStore(({ setZoom }) => setZoom);
  const canScrollX = useStore(({ canScrollX }) => canScrollX);
  const panModeActive = useStore(({ panModeActive }) => panModeActive);
  const togglePanMode = useStore(({ togglePanMode }) => togglePanMode);
  const [zoomSelected, setZoomSelected] = useState(zoomList.find(z => z.value === resolveZoom(readStoredZoom())) || zoomList[6]);

  // Raccourci Ctrl+M / Cmd+M. N'agit que si le bouton est affiché (canScrollX).
  // Cmd+M est aussi le raccourci macOS pour minimiser la fenêtre : preventDefault
  // fonctionne dans la plupart des navigateurs, mais certains (Safari) peuvent
  // quand même minimiser en plus de basculer le mode.
  useEffect(() => {
    if (!canScrollX) return undefined;
    const onKeyDown = (e) => {
      if (!(e.ctrlKey || e.metaKey) || e.altKey || e.key.toLowerCase() !== 'm') return;
      e.preventDefault();
      togglePanMode();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [canScrollX, togglePanMode]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
      <Button
        style={zoomButtonStyle}
        icon={<FontAwesomeIcon icon={icon({ name: 'magnifying-glass-minus', style: 'solid', family: 'duotone' })} style={{ fontSize: 20 }} />}
        onClick={() => {
          const zoomValue = zoomList.find(z => z.index === zoomSelected?.index - 1)
          if (zoomValue === undefined) return;
          setZoomSelected(zoomValue);
          setZoom(zoomValue.value)
        }}
        size='medium'
      />

      <NavbarSelector
        key="fontSizeSelector"
        tooltipContent={t('zoom-size')}
        onSelect={(e) => {
          const zoomValue = zoomList.find(z => z.value === e)

          setZoomSelected(zoomValue);
          setZoom(zoomValue.value)
        }}
        selectedValue={zoomSelected?.value}
        options={zoomList}
        searchable={false}
        arrow={false}
        customStyle={{
          borderRadius: 4,
          width: 75,
          margin: 0,
          height: 32,
          textAlign: 'center',
        }}
      />

      <Button
        style={zoomButtonStyle}
        icon={<FontAwesomeIcon icon={icon({ name: 'magnifying-glass-plus', style: 'solid', family: 'duotone' })} flip={'horizontal'} style={{ fontSize: 20 }} />}
        onClick={() => {
          const zoomValue = zoomList.find(z => z.index === zoomSelected?.index + 1)
          if (zoomValue === undefined) return;

          setZoomSelected(zoomValue);
          setZoom(zoomValue.value)
        }}
        size='medium'
      />

      {canScrollX && (
        <Tooltip
          title={panModeActive ? t('pan-mode-active-message') : t('pan-mode-toggle')}
          placement='bottom'
        >
          <Button
            style={zoomButtonStyle}
            icon={<FontAwesomeIcon icon={icon({ name: 'hand', style: 'solid', family: 'duotone' })} style={{ fontSize: 20 }} />}
            type={panModeActive ? 'primary' : 'default'}
            onClick={togglePanMode}
            size='medium'
          />
        </Tooltip>
      )}
    </div>
  );
};

export default ZoomControl;
